import React, { useEffect, useState } from "react";
import { Navbar, Button, Image, Container } from "react-bootstrap";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Header.css";

const FormalityHeader = ({ from }) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsSticky(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const callNumber = "+33972119472";
  const waNumber = "237677200200";

  const openWhatsApp = () => {
    window.open(`https://wa.me/${waNumber}`, "_blank", "noopener,noreferrer");
  };

  const getTitle = () => {
    switch (from) {
      case "company-modification":
        return "Modification des statuts";
      case "building-permit":
        return "Permis de bâtir";
      case "certificateSingleness":
        return "Certificat de célibat";
      case "certificateNationality":
        return "Certificat de nationalité";
      case "crimRecord":
        return "Extrait de casier judiciaire";
      case "customsRebate":
        return "Abattement douanier";
      case "eneo":
        return "Branchement ENEO";
      case "businessPlan":
        return "Business Plan";
      case "visualIdentity":
        return "Identité visuelle";
      case "importation":
        return "Autorisation d'importation";
      case "oapi":
        return "Protection OAPI";
      case "passport":
        return "Pré-enrôlement Passeport";
      case "camwater":
        return "Abonnement CAMWATER";
      case "visa-canada":
        return "Visa Canada";
      case "visa-cameroun":
        return "Visa Cameroun";
      case "visa-schengen":
        return "Visa Schengen";
      case "debt-recovery":
        return "Demande de recouvrement";
      case "resume":
        return "Paiement";
      case "trademark":
        return "Protection de la marque";
      case "taxRegistration":
        return "Attestation d'immatriculation";
      case "taxCompliance":
        return "Conformité fiscale";
      case "cnpsRegistration":
        return "Immatriculation CNPS";
      default:
        return "";
    }
  };

  return (
    <Navbar
      expand="lg"
      className={`app-navbar topbar ${isSticky ? "is-sticky" : ""} border-bottom`}
      aria-label="Barre d'en-tête de formalité"
    >
      <Container className="d-flex justify-content-between align-items-center">
        {/* Logo */}
        <Navbar.Brand as={Link} to="/" className="brand">
          <Image
            src="/images/logo-Cplatform.png"
            alt="Logo"
            width={200}
            height={55}
            className="brand-logo"
          />
        </Navbar.Brand>

        {/* Titre central */}
        <h5 className="formality-title flex-grow-1 text-center m-0">
          {getTitle()}
        </h5>

        {/* CTA téléphone / WhatsApp */}
        <div className="nav-actions">
          <Button
            type="button"
            className="btn-orange phone-cta"
            onClick={openWhatsApp}
            aria-label="Contacter par téléphone ou WhatsApp"
          >
            <FaPhoneAlt size={18} className="phone-cta-icon" />
            <span className="phone-text">
              {callNumber} / <FaWhatsapp size={20} className="wa-cta-icon" /> +{waNumber}
            </span>
          </Button>
        </div>
      </Container>
    </Navbar>
  );
};

export default FormalityHeader;
